
import {
  get, post, update, hapus, upload, download
} from './helpers'

// API GENERAL
export function getAllQuestion($token_ujian) {
  return get(`/peserta/kompetensi-dasar/all?token_ujian=${$token_ujian}`)
}

export function postJawaban($data) {
  return post(`/peserta/kompetensi-dasar/jawaban`, $data)
}

export function postMulaiKompetensiDasar($data) {
  return post(`/peserta/kompetensi-dasar/mulai`, $data)
}

export function submitUjian($token_ujian) {
  return get(`/peserta/kompetensi-dasar/submit?token_ujian=${$token_ujian}`)
}

export function syncNilaiPeserta() {
  return post(`/peserta/sync-nilai`)
}


